// This is a sample store which serves as an example

import { immer } from "zustand/middleware/immer";
import { create } from "zustand";
import { createSelectors } from "@/lib/storeUtils";
import { ConfirmDialogProps } from "@/components/dialog/confirm-dialog";

type DialogState = {
    open: boolean;
    resolveCallback: ((value?: unknown) => void) | null;
    dialogProps: ConfirmDialogProps;
    showAutoLogOutWarning: boolean;
    setOpen(open: boolean): void;
    setDialogProps(props: ConfirmDialogProps): void;
    setShowAutoLogOutWarning(showAutoLogOutWarning: boolean): void;
};

export const dialogStore = create(
    immer<DialogState>((set) => ({
        open: false,
        resolveCallback: null,
        showAutoLogOutWarning: false,
        dialogProps: {},
        setOpen(open: boolean) {
            set((state) => {
                state.open = open;
            });
        },
        setDialogProps(dialogProps: ConfirmDialogProps) {
            set((state) => {
                state.dialogProps = dialogProps;
            });
        },
        setShowAutoLogOutWarning(showAutoLogOutWarning: boolean) {
            set((state) => {
                state.showAutoLogOutWarning = showAutoLogOutWarning;
            });
        },
    }))
);

export const useDialogStore = createSelectors(dialogStore);
